import { render } from "./DenuvoTicketUpload.vue?vue&type=template&id=3cbd8132&scoped=true"
import script from "./DenuvoTicketUpload.vue?vue&type=script&lang=js"
export * from "./DenuvoTicketUpload.vue?vue&type=script&lang=js"

import "./DenuvoTicketUpload.vue?vue&type=style&index=0&id=3cbd8132&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cbd8132"]])

export default __exports__